<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <airport-selector
          v-model="airportOperation.airport_id"
          field-name="airport"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="airportOperation.reg_num"
          field-name="reg_num"
          rules="required"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <date-field
          v-model="airportOperation.date"
          field-name="date"
          rules="required|date"
          autofocus
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
      >
        <time-field
          v-model="airportOperation.takeoff_time"
          field-name="takeoff_time"
          rules="required|time"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <time-field
          v-model="airportOperation.landing_time"
          field-name="landing_time"
          rules="required|time"
          type="text"
        />
      </v-col>
      <v-col
        cols="12"
        md="4"
      >
        <validated-text-field
          v-model="airportOperation.touch_and_go"
          field-name="touch_and_go"
          rules="required|numeric|min_value:0|max_value:50"
          type="number"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditAirportOperation',
    props: {
      airportOperation: Object,
    },
  }
</script>
